<template lang="pug">
  section.section-color.section-param
    v-container.container-footer.mx-auto(fluid)
      v-card.card-footer.d-flex.elevation-0(v-if="$vuetify.breakpoint.smAndDown" fluid)
        v-card.card-background.flex-column.elevation-0
          a.a-img-footer
            v-img.img-footer(
              src="@/assets/logo/logo_outstaff.svg"
              @click="$vuetify.goTo('#home')"
              contain
              )
            v-spacer
          a.a-img-footer(:href="urlARDA" target="_blank")
            v-img.img-footer.img-partner(
              src="@/assets/logo/logo_ARDA.svg"
              contain
              )
        v-spacer
        v-card.card-background.flex-column.elevation-0
          v-card.infoStyle.ml-auto.elevation-0
            a.text.color-grey.medium.font-style(href="tel:+79525378839") +7 952 537-88-39
            a.text.color-grey.medium(href="mailto:sales@bls-soft.ru") sales@bls-soft.ru
          v-card.infoStyle.mobile-copyright.ml-auto.elevation-0
            p.text.classic.font-style.mb-0 {{periodTextMobile}}
            p.text.classic.mb-0 Все права защищены

      v-card.company-info.company-info-center-style-mobile.elevation-0(v-if="$vuetify.breakpoint.smAndDown" fluid)
          p.text.classic.medium.font-style.mb-0 {{ periodTextCompanyInfoMobile }}
      v-card.card-footer.d-flex.elevation-0.justify-space-between(v-else fluid)
        a.a-img-footer
          v-img.img-footer(
            src="@/assets/logo/logo_outstaff.svg"
            @click="$vuetify.goTo('#home')"
            contain
            )
        v-card.info-center-style.elevation-0
          p.text.medium.mb-0 {{periodText}}
          p.text.medium.mb-0 Все права защищены
        a.a-img-footer(:href="urlARDA" target="_blank")
          v-img.img-footer.img-partner(
            src="@/assets/logo/logo_ARDA.svg"
            contain
            )
        v-card.infoStyle.elevation-0
          a.text.medium(href="tel:+79525378839") +7 952 537 88 39
          a.text.medium(href="mailto:sales@bls-soft.ru") sales@bls-soft.ru
      v-card.company-info.company-info-center-style.elevation-0(v-if="!$vuetify.breakpoint.smAndDown" fluid)
          p.text.classic.medium.font-style.mb-0(v-html="periodTextCompanyInfo")
</template>

<script>
export default {
  name: "Footer",
  computed: {
      periodText() {
        return `©ООО "BLS-SOFT", 2019-${new Date().getFullYear()}`
      },
      periodTextMobile() {
        return `©ООО "BLS-SOFT" 2019-${new Date().getFullYear()}`
      },
      periodTextCompanyInfo() {
        return `ООО «БЛС-Софт», ИНН 6732233075, ОГРН 1226700013803, г. Смоленск, ул. Генерала Паскевича, д. 5, пом. 3-11<br>
        ОКВЭД 62.01, осуществляет деятельность по кодам 1.01, 1.05, 3.01, 8.01 в соответствии с приказом МинЦифры № 449 от 11.05.2023 г.`
      },
      periodTextCompanyInfoMobile() {
        return `ООО «БЛС-Софт»,
        ИНН 6732233075, ОГРН 1226700013803,
        г. Смоленск, ул. Генерала Паскевича, д. 5, пом. 3-11
        ОКВЭД 62.01, осуществляет деятельность по кодам 
        1.01, 1.05, 3.01, 8.01 
        в соответствии с приказом МинЦифры № 449 от 11.05.2023 г.`
      },
      urlARDA(){
        return 'https://it.arda.digital/'
      }
  }
}
</script>

<style lang="sass" scoped>
  @import "scss/variables.scss"
  @import "scss/colors.scss"
  
  .img-partner
    margin-top: -1rem !important
    margin-left: 0.1rem
    max-width: 5.6rem !important

  .a-img-footer
    flex-wrap: wrap
    align-self: start

  .company-info
    margin-bottom: 1rem
    color: $lightGrey
    display: flex
    background-color: transparent
    align-items: center
    justify-content: center
    text-align: center
    margin-left: $marginMax
    margin-right: $marginMax

  .company-info-center-style-mobile
    margin-top: 1rem
    white-space: pre-line
    .text
      font-size: 14px

  .company-info-center-style
    margin-top: 3rem
    font-family: GothamProMedium
    .text
      font-size: 12px
  
  @media(max-width: $xsOnly)
    .text
      line-height: 11px !important
      font-size: 12px !important

    .font-style
      margin-bottom: 7px

    .img-footer
      margin-top: 1px

  @media(min-width: $xsMiddle)
    .mobile-copyright
      margin-top: 3rem 

  @media(max-width: $xsMiddle)
    .mobile-copyright
      margin-top: 2.4rem 

  @media(min-width: $smAndUp)
    .mobile-copyright
      margin-top: 0rem 

  @media(max-width: $xsMiddle)
    .infoStyle .text
      margin-left: auto
      text-align: end
      max-width: 150px
      
  @media(max-width: $smAndDown)
    .img-footer
      max-width: max(90px, 16%)

  @media(min-width: $smOnlyStart) and (max-width: $smOnlyEnd)
    .text
      font-size: 14px

      .img-footer
      margin-top: 5px

  @media(min-width: $mdOnlyStart) and (max-width: $mdOnlyEnd)
    .text
      font-size: 16px

  @media(min-width: $mdAndUp)
    .img-footer
      max-width: min(calc(57px + 6vw), 163px)
      margin-top: 6px

  @media(min-width: $lgOnlyStart) and (max-width: 1620px)
    .text
      font-size: 17px

  @media(min-width: 1621px)
    .text
      font-size: 18px

  @media(min-width: $xxl)
    .container-footer
      max-width: $maxWidthContainer
      margin: auto

  .container-footer
    background-size: auto auto
    justify-content: center
    background-color: $backgroundContainer

  .card-footer
    display: flex
    background-color: $backgroundContainer
    margin-left: $marginMax
    margin-right: $marginMax
    margin-top: 5%
    max-width: $maxWidthContent

  .card-background
    background-color: $backgroundContainer
  
  .img-footer
    align-self: start
    ::v-deep
      .v-image__image
        background-position: left top !important

  .info-center-style
    display: flex
    flex-direction: column
    background-color: transparent
    align-self: start
    max-width: 300px
    margin-left: 15%

    .text
      text-decoration: none
      text-align: center
      color: $lightGrey

  .medium
    font-family: GothamProMedium

  .classic
    font-family: GothamProClassic

  .infoStyle
    display: flex
    flex-direction: column
    background-color: transparent
    align-self: start
    justify-content: flex-end
    max-width: 230px
    .text
      text-decoration: none
      margin-left: auto
      color: $lightGrey
      &:hover
        color: $blueBasic

  .color-grey
    color: $grey !important

  .margin-footer
    margin-left: 24%
</style>